// extracted by mini-css-extract-plugin
export default {"historySection":"styles_historySection__mP6oU","header":"styles_header__wGdix","title":"styles_title__BqlrX"};